module.exports = __webpack_public_path__ + "img/step27_a_install_left_adapter.0eb7503b.png";